var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: _vm.classes,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.select.apply(null, arguments)
        },
        mousedown: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _vm._t("default", function() {
        return [_vm._v(_vm._s(_vm.showLabel))]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-703f2484", { render: render, staticRenderFns: staticRenderFns })
  }
}